<div class="relative">
  <div class="overlayerContent">

    <div class="md:p-5 p-2 relative">
      <div class="bg-primary-500/70 absolute backdrop-blur-md inset-0"></div>
      <img src="/assets/images/patternHover.png"
           alt=""
           class="absolute inset-0  w-full h-full object-fill">

      <div class="mt-3 flex flex-col items-center justify-center gap-4  md:w-8/12 w-11/12 mx-auto min-h-[340px] intro-y"
           [style]="{'--order':1, 'opacity' : 0}">
        <div class="flex justify-end my-2">
          <button (click)="exitHover.emit(null)" mat-mini-fab class="!bg-white/50">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="flex flex-col items-center gap-3 bg-white/30 mix-blend-screen md:p-5 p-3 rounded-md w-full"
             (click)="$event.stopPropagation()">
          <div class="text-white md:text-xl text-lg ">{{ "Tafuta Taasisi"|concat|translate }}</div>
          <div class="w-11/12 mx-auto flex items-center bg-[#F8F9F9] p-3 rounded-md">
            <input (input)="onSearchChange()"
                   [formControl]="searchedKeyword"
                   class="w-full outline-none bg-transparent text-black placeholder:text-[#B0AEAE]"
                   matInput
                   placeholder="{{'Tafuta Taasisi'|concat|translate }}">
            <mat-icon svgIcon="landingSearch" class="text-gray-400" style="height:20px;width:20px"></mat-icon>

          </div>
          <div class="flex flex-wrap gap-1 max-h-[40vh] overflow-y-auto w-full">
            <div
              class="bg-white px-5 py-2 rounded-lg shadow-sm hover:cursor-pointer hover:scale-[0.98] transition-all ease-linear duration-200"
              *ngFor="let institution of filteredInstitutions | async"
              (click)="onItemSelected(institution)">
              <span>{{ institution.institutionName | titlecase }}</span>
            </div>
          </div>
        </div>
      </div>
      <div (click)="exitHover.emit(null)" class="min-h-[170vh] w-full backdrop-blur-lg"></div>
    </div>
  </div>
</div>
